import { useEffect, useRef } from 'react'

/** USB scanners type a code faster than any person and finish with Enter. */
const MAX_GAP_MS = 35
const MIN_LENGTH = 6

/**
 * Listens for keyboard-wedge scanner bursts anywhere on the page, so a scan works without the search box focused.
 * Input inside fields is left alone; the search box handles its own Enter and falls back to a barcode lookup.
 */
export const useBarcodeScanner = (onScan: (code: string) => void, enabled = true) => {
  const buffer = useRef('')
  const last = useRef(0)
  const cb = useRef(onScan)
  cb.current = onScan

  useEffect(() => {
    if (!enabled) return
    const onKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement
      if (['INPUT', 'TEXTAREA'].includes(target.tagName)) return
      const now = performance.now()
      if (now - last.current > MAX_GAP_MS) buffer.current = ''
      last.current = now

      if (e.key === 'Enter' && buffer.current.length >= MIN_LENGTH) {
        e.preventDefault()
        cb.current(buffer.current)
        buffer.current = ''
      } else if (e.key.length === 1) {
        buffer.current += e.key
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [enabled])
}
